import { GenericAbortSignal } from 'axios';

import http from 'services/http';

// The portal registry (OLIO-3072): which portal source systems exist and what to call
// them. `systemName` is the identifier on the wire — the `source_system` value on
// workflows, scripts, and settings; `displayName` is what we render for it. Served by
// olio-api from its portal_systems table, so adding a portal is a data change there,
// not a code change here.

// How a collecting surface renders and validates a field — the api's collector
// vocabulary, not the workflow engine's storage types.
export type CollectedFieldType = 'text' | 'date' | 'select' | 'ssn' | 'name' | 'facility' | 'documents';

// A field this portal is configured to collect during retrieval (OLIO-3074). The
// effective set: the api already merged the non-negotiables in.
export interface RetrievalFieldOption {
  name: string;
  label: string;
  type: CollectedFieldType;
  cardinality?: 'many';
  required: boolean;
}

export interface ScanFieldOption {
  name: string;
  label: string;
}

export interface PortalSystemOption {
  id: string;
  systemName: string;
  displayName: string;
  primaryId: string;
  retrievalFields: RetrievalFieldOption[];
  scanFields: ScanFieldOption[];
  sweepTableFields: string[];
}

export const portalSystemQueryKeys = {
  base: ['portalSystems'] as const,
};

export async function indexPortalSystems(signal?: GenericAbortSignal) {
  return http.get<{ data: PortalSystemOption[] }>('portal_systems', { signal }).then((res) => res.data.data);
}
